import { WORKSPACE_ROLE_LABEL } from '@constants/workspaceRoles';

/** Normalize API role strings (e.g. "Role.GUEST" → "guest"). */
export function normalizeWorkspaceRole(role) {
  if (!role) return '';
  return String(role)
    .replace(/^Role\./i, '')
    .toLowerCase();
}

export function formatWorkspaceRole(role) {
  const normalized = normalizeWorkspaceRole(role);
  return WORKSPACE_ROLE_LABEL[normalized] ?? normalized;
}

/** Format a member count with correct singular/plural ("1 member", "2 members"). */
export function formatMemberCount(count) {
  const n = count || 0;
  return `${n} member${n === 1 ? '' : 's'}`;
}
